import { ButtonHTMLAttributes, forwardRef } from 'react';
import classNames from 'classnames';
import { ButtonVariants, ButtonSizes } from '.';
import styles from './Button.module.scss';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	/** Вариант кнопки */
	variant?: ButtonVariants;
	/** Размер */
	size?: ButtonSizes;
	/** По умолчанию мез заливки */
	outline?: boolean;
	/** Кнопка активна ( нужно для работы выпадающих менюшек ) */
	active?: boolean;
	/** Недоступна */
	disable?: boolean;
	/** Тробер */
	isWait?: boolean;
	/** С рамкой */
	bordered?: boolean;
	/** На всю ширину блока */
	block?: boolean;
}

/** Компонента стилизованной кнопки */
const Button = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
	const {
		variant = 'blue',
		type = 'button',
		size = 'std',
		outline = false,
		active = false,
		disable = false,
		isWait = false,
		bordered = false,
		block = false,
		className,
		children,
		...otherProps
	} = props;

	const buttonClasses = classNames(
		styles.button,
		styles[`button_${variant}`],
		styles[size],
		{
			[styles.outline]: outline,
			[styles.active]: active,
			[styles.disable]: disable,
			[styles.bordered]: bordered,
			[styles.block]: block,
		},
		className,
	);

	return (
		<button
			ref={ref}
			type={type}
			className={buttonClasses}
			disabled={disable || isWait}
			{...otherProps}
		>
			{isWait && <div className={styles.trobber} />}
			<div
				className={classNames('button-font', styles.content, {
					[styles.waiting]: isWait,
				})}
			>
				{children}
			</div>
		</button>
	);
});

export default Button;
